import { t } from "../hooks/translations"
import css from "../style.module.scss"

export const SuccessScreen = function SuccessScreen() {
  return (
    <div>
      <p className={css.paragraph} style={{ textAlign: "center", marginBottom: 16 }}>
        {t("thanks_for_joining")}
      </p>
      <p className={css.paragraph} style={{ marginBottom: 32 }}>
        {t("you_can_access")}
      </p>
      <button className={css.button} type="submit" onClick={() => window.location.reload()}>
        {t("finish")}
      </button>
    </div>
  )
}
